<template>
  <div class="go-in">
    <banner img="../assets/img/bgtop.jpg" title="走进善信" />
    <div class="section" v-loading="loading">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">公司简介</p>
            <p class="eTitle">ABOUT US</p>
            <p class="content">
              成立于2019年12月， 目前国内最先进的智慧居家养老助残信息云平台。
              凭借多年软件产品开发经验和团队优势，决心以高起点高要求高规划来进行养老事业的顶层设计，独创的移动端设计，成为全国最为先进的符合国家养老服务标准的智能化信息养老平台，该项技术已获得国家计算机软件自主知识产权认证，它整合了物联网、大数据、云计算、人工智能等先进技术手段，对老年人的生活照料、医疗保健、文化娱乐、精神慰藉等多方面进行全方位整合，使养老服务从“无人照料”到“精准服务”、从“单一模式”到“多元化”转变。
            </p>
          </div>
          <div class="summary-right">
            <img src="../assets/img/jianjietopmin.png" alt />
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <!-- 发展历程 -->
        <div class="content-course">
          <div class="top">
            <h3>智慧医养服务商圈</h3>
            <p>Business Circle</p>
            <div class="border"></div>
            <div class="timeline"></div>
          </div>
          <div class="course-time">
            <swiper :options="swiperOption" ref="mySwiper">
              <swiper-slide v-for="(item, index) in courseList" :key="index">
                <div class="time-show">
                  <div class="time-show-item" v-for="(courseOne, one) in item" :key="one">
                    <div class="item-top" :class="{ 'order-top': one % 2 === 1 }"></div>
                    <el-divider>
                      <i class="el-icon-mobile-phone"></i>
                    </el-divider>
                    <div class="item-bottom" :class="{ order: one % 2 === 1 }">
                      <div class="item-bottom-content">
                        <p>{{ courseOne.Content }}</p>
                        <p class="Year">{{ courseOne.Year }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>

        <div class="content-culture">
          <h3>企业文化</h3>
          <h3>CULTURE</h3>
          <p>让所有老人晚年都有尊严的幸福生活</p>
          <span>1. 让所有老年人和残障人士，晚年都能过上有尊严的幸福生活!</span>
          <span>2. 引领中国医养结合养老助残行业，做专业医养结合的养老助残服务平台!</span>
          <span
            >3. 尽善心、行善事，福泽后世。专注于医养结合的健康养老助残事业保持行业领
            先地位。</span
          >
        </div>
        <!-- 公司荣誉 -->
        <div class="content-honor">
          <div class="honor-big-img">
            <el-dialog :title="dialogTitle" :visible.sync="dialogTableVisible">
              <img v-lazy="dialogUrl" alt />
            </el-dialog>
          </div>
          <div class="top">
            <h3>资质荣誉</h3>
            <p>HONOR</p>
            <div class="border"></div>
          </div>
          <ul class="honor-show">
            <li>
              <img src="../assets/img/1.jpg" />
            </li>
            <li>
              <img src="../assets/img/2.jpg" />
            </li>
            <li>
              <img src="../assets/img/3.jpg" />
            </li>
            <li>
              <img src="../assets/img/4.jpg" />
            </li>
            <li>
              <img src="../assets/img/5.jpg" />
            </li>
            <li>
              <img src="../assets/img/6.jpg" />
            </li>
          </ul>
          <!-- <p>点击图片查看大图</p> -->
        </div>
        <!-- 团队风采 -->
        <div class="content-team">
          <div class="top">
            <h3>团队风采</h3>
            <p>TEAM</p>
          </div>
          <el-carousel :interval="4000" type="card">
            <el-carousel-item v-for="(team, index) in teamItem" :key="index">
              <div
                class="swiper-img"
                v-lazy:background-image="team"
              ></div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- 合作伙伴 -->
        <div class="content-partner">
          <div class="top">
            <h3>合作伙伴</h3>
            <p>RARTNERS</p>
            <ul class="partner-img">
              <li v-for="(partner, i) in partnerImg" :key="i">
                <img :src="partner" alt />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Banner,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      loading: false,
      honorList: [],
      partnerImg: [
        require('../assets/img/Goin_7.jpg'),
        require('../assets/img/Goin_8.jpg'),
        require('../assets/img/Goin_4.jpg'),
      ],
      courseList: [
        [
          {
            Content: "建立实时健康监测、健康预警 与康复疗养一体化服务。",
            Id: 1,
            Year: "健康医疗",
          },
          {
            Content: "建立标准化、规范化、可评估的服务体系。",
            Id: 1,
            Year: "生活服务",
          },
        ],
        [
          {
            Content: "建立营养膳食与有机食材全程化服务。",
            Id: 1,
            Year: "营养膳食",
          },
          {
            Content: "建立线上商城与线下惠民超市原产地直采直供商品的 O20销售服务。",
            Id: 1,
            Year: "便民商城",
          },
        ],
        [
          {
            Content: "建立兴趣圈子与候鸟式养老相 结合的娱乐养老服务。",
            Id: 1,
            Year: "旅居娱乐",
          },
          {
            Content: "打造10000-50000平方米的 医养结合幸福乐园。",
            Id: 1,
            Year: "康乐福地",
          },
        ],
        [
          {
            Content: "全面满足老人休闲、娱乐、健身、疗养、购物等需求。",
            Id: 1,
            Year: "颐养乐都",
          },
          {
            Content: "通过线上线下联动，构建一个完善的养老生态链",
            Id: 1,
            Year: "颐养乐都",
          },
        ],
      ],
      teamItem: [
        require('../assets/img/Goin_1.jpg'),
        require('../assets/img/Goin_2.jpg'),
        require('../assets/img/Goin_3.jpg'),
        require('../assets/img/Goin_4.jpg'),
        require('../assets/img/Goin_5.jpg'),
        require('../assets/img/Goin_6.jpg'),
      ],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: "",
    };
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: rgb(255, 118, 64, 0.9);
  position: relative;
  overflow: hidden;
  .section {
    width: 100%;
    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #fff;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 100px 0;
        .summary-left {
          width: 600px;
          .title {
            font-size: 25px;
            color: #e13834;
          }
          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }
          .content {
            color: #14679f;
            font-size: 14px;
            text-indent: 25px;
            line-height: 30px;
          }
        }

        .summary-right {
          width: 400px;
          height: 310px;
          border: 2px solid rgb(255, 118, 64,1);
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;

          img {
            width: 360px;
            height: 270px;
            margin-top: 20px;
            //animation: imgbo 4s infinite;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;
        .course-time {
          width: 1000px;
          height: 400px;
          margin: 20px auto;
          .swiper-container {
            height: 100%;
          }
          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;
            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }
              .item-bottom {
                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: rgb(255, 118, 64,0.9);
                  margin: 20px 0;
                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                  .Year{
                    font-weight: bold;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 350px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: rgb(255, 118, 64,0.3);
        h3 {
          color: #3c6088;
          font-size: 26px;
        }
        p {
          color: #fff;
          font-size: 23px;
          padding: 5px 0;
        }
        span {
          font-weight: 400;
          line-height: 1.6;
          font-size: 14px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        padding: 50px 0;
        .honor-show {
          width: 1000px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            width: 220px;
            height: 320px;
            margin-left: 15px;
            list-style: none;
            border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;
        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;
        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }
  40% {
    border: solid rgb(255, 255, 255) 2px;
  }
  60% {
    border: solid rgb(255, 255, 255) 2px;
  }
  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }
  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}
.el-divider--horizontal {
  margin: 1px 0;
}

.top {
  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }
  h3 {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}
// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}
.order-top {
  order: 1;
}
.el-divider {
  background-color: red;
  height: 3px;
  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}
.el-divider-active {
  background-color: #3c6088;
}
.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;
  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
}
</style>